.legalContent {
  max-width: 820px;
  margin: 0 auto;
  padding: 96px 24px 120px;
  color: #1c2745;
  font-size: 15px;
  line-height: 1.78;
  letter-spacing: -0.005em;
}

.legalContent .header {
  margin-bottom: 48px;
  padding-bottom: 28px;
  border-bottom: 1px solid #e5edfa;
}

.legalContent h1 {
  margin: 0 0 18px;
  color: #07183f;
  font-size: 34px;
  font-weight: 900;
  line-height: 1.2;
  letter-spacing: -0.02em;
}

.legalContent .header p {
  margin: 0;
  color: #4a5878;
  font-size: 15px;
  line-height: 1.75;
}

.legalContent section {
  margin-top: 36px;
}

.legalContent h2 {
  margin: 0 0 14px;
  color: #07183f;
  font-size: 19px;
  font-weight: 800;
  line-height: 1.35;
  letter-spacing: -0.01em;
}

.legalContent p {
  margin: 0 0 12px;
  color: #2b3958;
}

.legalContent ul,
.legalContent ol {
  margin: 0;
  padding-left: 22px;
  color: #2b3958;
}

.legalContent li {
  margin-bottom: 6px;
}

.legalContent li::marker {
  color: #5e6b85;
}

.legalContent a {
  color: #1e4dc4;
  text-decoration: none;
  font-weight: 700;
}

.legalContent a:hover {
  text-decoration: underline;
}

.legalContent strong {
  color: #07183f;
  font-weight: 800;
}

.legalContent .footer {
  margin-top: 56px;
  padding-top: 28px;
  border-top: 1px solid #e5edfa;
  color: #5e6b85;
  font-size: 13px;
}

.legalContent .footer p {
  margin: 0 0 4px;
  color: inherit;
}

@media (max-width: 720px) {
  .legalContent {
    padding: 72px 20px 88px;
    font-size: 14.5px;
  }

  .legalContent h1 {
    font-size: 28px;
  }

  .legalContent h2 {
    font-size: 17px;
  }
}
